import React from 'react';
import parse from "html-react-parser";

const HoverImageIcon = ({ icon, svg_2d, altText, handleZoomCardThumbnail }) => {
    function removeWidthAndHeightAttributes(svgString) {
        // Use regular expression to remove the width and height attributes
        return svgString.replace(/width="[^"]*"/, '').replace(/height="[^"]*"/, '');
    }


    const svg = parse(removeWidthAndHeightAttributes(svg_2d));
    return (
        <div className="relative group inline-block w-full">
            {/* Main Icon */}
            <div className="w-10 ml-3 flex items-center h-full transition-transform transform group-hover:scale-110 group-hover:shadow-lg">
                {svg_2d && parse(removeWidthAndHeightAttributes(svg_2d))}
            </div>

            {/* Hover Image */}
            <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 -translate-y-2 w-48 opacity-0 transition-all duration-300 ease-in-out group-hover:opacity-100 group-hover:scale-110 group-hover:-translate-y-4 group-hover:shadow-2xl">
                <div className="bg-white rounded-lg p-2 shadow-lg transition-transform duration-300 ease-in-out">
                    {svg_2d && svg}
                </div>
            </div>
        </div>
    );
};

export default HoverImageIcon;